import reducer from './reducers';
import * as actions from './actions';
import * as types from './types';

export const confirmModalActions = actions;
export const confirmModalReducer = reducer;
export const confirmModalTypes = types;
